import {Component, OnInit} from '@angular/core';
import {MaintenanceStatus} from "../../models/maintenance";
import {ActivatedRoute, Router} from "@angular/router";
import {AngularFireAuth} from "@angular/fire/auth";
import {NotificationManagerService} from "../../services/notification-manager.service";
import {AngularFireDatabase} from "@angular/fire/database";
import {AngularFirestore} from "@angular/fire/firestore";
import {MaintenanceManagerService} from "../../services/maintenance-manager.service";
import {Assistance, AssistanceType} from "../../models/assistance";
import {AccountManagerService} from "../../services/account-manager-service";
import {environment} from "@environments/environment";
import {HttpClient} from "@angular/common/http";
import {DEBUG, DebugService} from "../../services/debug.service";

@Component({
  selector: 'app-authenticated-videocall-page',
  templateUrl: './authenticated-videocall-page.component.html',
  styleUrls: ['./authenticated-videocall-page.component.scss']
})
export class AuthenticatedVideocallPageComponent implements OnInit {

  loading = true;
  error = false;
  isSignedIn = false;

  assistance: Assistance;

  companyId: string;
  authToken: string;
  maintenanceId: string;
  eventId: string;
  expertFirstName: string;
  expertLastName: string;
  logo: string;
  color: string;

  // TODO remove firebase from here
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AngularFireAuth,
    private notificationManagerService: NotificationManagerService,
    private db: AngularFireDatabase,
    private angularFirestore: AngularFirestore,
    private maintenanceManagerService: MaintenanceManagerService,
    private accountManagerService: AccountManagerService,
    private debugService: DebugService,
    private httpClient: HttpClient,
  ) { }

  ngOnInit(): void {

    this.route.queryParamMap.subscribe(async queryParamMap => {

      this.companyId = queryParamMap.get('uid');
      this.authToken = queryParamMap.get('token');
      this.maintenanceId = queryParamMap.get('maintenanceId');
      this.eventId = queryParamMap.get('eventId');
      this.expertFirstName = queryParamMap.get('expertFirstName');
      this.expertLastName = queryParamMap.get('expertLastName');
      this.logo = queryParamMap.get('logo');
      this.color = queryParamMap.get('color');

      // Force anonymous if not name or surname is provided
      this.expertFirstName = this.expertFirstName.length == 0 && this.expertLastName.length == 0 ? 'Anonymous' : this.expertFirstName;

      await this.accountManagerService.loginWithCustomToken(this.authToken);

      this.assistance = new Assistance();
      this.assistance.maintenance = await this.maintenanceManagerService.getMaintenance(this.maintenanceId);
      this.assistance.id = this.eventId;

      // Check if expert can access the current maintenance
      switch (this.assistance.maintenance.status) {
        case MaintenanceStatus.OPEN:
          await this.setMaintenanceStatus(MaintenanceStatus.TAKEN);
          break;
        case MaintenanceStatus.CLOSED:
          this.onClosed();
          return;
      }

      await this.sendNotification();

      this.loading = false;

    });

  }

  async setMaintenanceStatus(status: MaintenanceStatus) {
    await this.maintenanceManagerService.setMaintenanceStatus(this.assistance.maintenance, status);
  }

  onClosed() {
    this.router.navigate(['closed'], { relativeTo: this.route });
  }

  async sendNotification() {

    // Get all users from tilly server
    let uids: { firebaseID: string }[] = await this.httpClient.get<{ firebaseID: string }[]>(
      `${environment.tilly.endpoint}/chat/ticket_${this.eventId}/room/100/getUsers`,
    ).toPromise();

    // Filter out non useful users (and exclude me)
    uids = uids.filter(uid => uid.firebaseID !== '' && uid.firebaseID != this.accountManagerService.account.authProviderId);

    uids.forEach(uid => {

      this.debugService.log(DEBUG.LIVE_ASSISTANCE, `Sending notification to user with ID ${uid}`);

      this.notificationManagerService.sendNotification('Operator ready', 'Click to get assistance from the operator', uid.firebaseID, {
        notif_type: 'operator_ready',
        chatId: this.eventId,
        roomId: 100,
      });

    });

  }

  get AssistanceType() { return AssistanceType }

}
